import React from "react";
import Footer from "../footer/Footer";
import VTVenueSellVTHistory2 from "../page/VTVenueSellVTHistory2";
import Header from "../header/Header";

export default function LandingVenueSellVTHistory({page}) {
    return (
        <>
            <Header headerType="AdminSellOnly"/>
            <VTVenueSellVTHistory2/>
            <Footer/>
        </>
    );
}